import React, { useEffect, useCallback, useRef, useState } from 'react';
import ProductPersoanlInfo from '../product/productPersoanlInfo';
import DaumPostcode, { useDaumPostcodePopup } from 'react-daum-postcode';
import { postcodeScriptUrl } from 'react-daum-postcode/lib/loadPostcode';
import Confirmodal from './confirmModal';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import productPage from '../product/productPage';

const ContactProduct = () => {
  const { pathname } = useLocation();
  const productRef = useRef(null);
  const useRefs = useRef([]);
  const [radio, setRadio] = useState('EG');
  const open = useDaumPostcodePopup(postcodeScriptUrl);
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const emailForm = /^[a-zA-Z]+\.[a-zA-Z]+$/;
  const emailId = /^[A-Za-z0-9-._]*$/g;

  const initialValue = {
    kind_gubun: 'EG',
    qSize: '30',
    cor_name: '',
    zipcode: '',
    addr: '',
    addr_detail: '',
    mng_name: '',
    phone1: '010',
    phone2: '',
    phone3: '',
    emailAccount: '',
    emailDomain: '',
    contents: '',
  };
  const [value, setValue] = useState({ ...initialValue });
  const [agree, setAgree] = useState(false);
  const {
    qSize,
    cor_name,
    zipcode,
    addr,
    addr_detail,
    mng_name,
    phone1,
    phone2,
    phone3,
    emailAccount,
    emailDomain,
    contents,
  } = value;
  const [closePopUp, setClosePopUp] = useState(false);
  const isResponsive = useMediaQuery({ minDeviceWidth: 1290 });

  const handleComplete = (data) => {
    setValue({ ...value, zipcode: data.zonecode, addr: data.roadAddress });
  };

  const handleOnChange = (e) => {
    if (e.target.name === 'kind_gubun') {
      setRadio(e.target.value);
      setValue({ ...value, kind_gubun: e.target.value });
    } else {
      setValue({
        ...value,
        [e.target.name]: e.target.value,
      });
    }
  };

  const onSubmitRequest = useCallback(
    async (e) => {
      // 문의하기 요청
      e.preventDefault();
      if (loading) {
        return false;
      }
      for (let i = 0; i < useRefs.current.length; i++) {
        if (useRefs.current[i].value === '' || !useRefs.current[i].value.trim()) {
          alert(useRefs.current[i].title);
          useRefs.current[i].focus();
          return false;
        }
      }
      if (useRefs.current[6]?.value?.length < 3) {
        alert('연락처를 확인해주세요.');
        useRefs.current[6].focus();
        return false;
      }
      if (useRefs.current[7]?.value?.length < 4) {
        alert('연락처를 확인해주세요.');
        useRefs.current[7].focus();
        return false;
      }
      if (!emailId.test(emailAccount)) {
        alert('이메일 아이디를 확인해주세요. (특수문자는 ".-_"만 허용됩니다.)');
        useRefs.current[8].focus();
        return false;
      }
      if (!emailForm.test(emailDomain)) {
        alert('이메일 도메인을 확인해주세요');
        useRefs.current[9].focus();
        return false;
      }
      if (agree === false) {
        alert('개인정보 수집 및 이용을 동의해주세요.');
        return false;
      }
      try {
        setLoading(true);
        const data = value;
        delete data?.phone1;
        delete data?.phone2;
        delete data?.phone3;
        delete data?.emailAccount;
        delete data?.emailDomain;

        await axios
          .post(
            'https://backwithus.kiwontech.com/customer/ask/save',
            {
              ...data,
              phone: `${phone1}-${phone2}-${phone3}`,
              email: `${emailAccount}@${emailDomain}`,
            },
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            },
          )
          .then((res) => {
            setValue({ ...initialValue });
            setRadio('EG');
            setAgree(false);
          });
      } catch (error) {
        alert('오류가 발생했습니다. 관리자에게 연락 부탁드립니다.');
      } finally {
        setLoading(false);
      }
      // 팝업 닫기
      setClosePopUp((prev) => !prev);
    },
    [value, agree],
  );

  const closePopup = useCallback(() => {
    setConfirm(true);
    setClosePopUp(!closePopUp);
  }, [closePopUp, setClosePopUp, confirm, setConfirm]);

  useEffect(() => {
    if (pathname === '/contact-us/product/contact-us') {
      const posY = productRef?.current?.offsetTop;
      window.scrollTo({
        top: posY,
        behavior: 'smooth',
      });
    }
  }, [pathname]);

  useEffect(() => {
    if (confirm === true) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [confirm]);

  return (
    <>
      <section className="common contactProductMain">
        <div className="container">
          <div className="mainTit contactTit">
            <h2>제품문의</h2>
            <p>Home > Contact Us > 제품문의</p>
          </div>
        </div>
      </section>
      <section className="contactProduct" ref={productRef}>
        <form onSubmit={onSubmitRequest}>
          <div className="w1200">
            <div className="tit">
              <h2>제품문의</h2>
              <p className="notice">
                신속하고 정확한 상담을 위해 아래 내용을 <br />
                작성해 주시기 바랍니다.
              </p>
            </div>
            <div className="pd50">
              <div className="inputForm">
                <label className="productType">
                  <span className="productTypeTitle">제품 종류</span>
                  <div className="radioFlex flex">
                    <label className="radioBox">
                      <input
                        type="radio"
                        className="check_box"
                        name="kind_gubun"
                        value="EG"
                        onChange={handleOnChange}
                        checked={radio === 'EG'}
                      />
                      <span className="checkmark"></span>
                      <span className="productBtn">EG-Platform</span>
                    </label>
                    <label className="radioBox">
                      <input
                        type="radio"
                        className="check_box"
                        name="kind_gubun"
                        value="SO"
                        onChange={handleOnChange}
                        checked={radio === 'SO'}
                      />
                      <span className="checkmark"></span>
                      <span className="productBtn">SentinelOne</span>
                    </label>
                    <label className="radioBox">
                      <input
                        type="radio"
                        className="check_box"
                        name="kind_gubun"
                        value="BP"
                        onChange={handleOnChange}
                        checked={radio === 'BP'}
                      />
                      <span className="checkmark"></span>
                      <span className="productBtn">BaroPAM</span>
                    </label>
                  </div>
                </label>
                <label className="wp100">
                  <span>회사 규모</span>
                  <select
                    className="companySize"
                    onChange={handleOnChange}
                    value={qSize}
                    name="qSize"
                    ref={(el) => (useRefs.current[0] = el)}
                    title="회사규모를 입력해주세요."
                  >
                    <option value="30" key="30">
                      30명 이하
                    </option>
                    <option value="50" key="50">
                      50명 이하
                    </option>
                    <option value="100" key="100">
                      100명 이하
                    </option>
                    <option value="300" key="300">
                      300명 이하
                    </option>
                    <option value="500" key="500">
                      500명 이하
                    </option>
                    <option value="1000" key="1000">
                      1000명 이하
                    </option>
                    <option value="9999" key="9999">
                      1000명 초과
                    </option>
                  </select>
                </label>
                <div className="gather flex">
                  <div className="left flex_column">
                    <label className="wp100">
                      <span>회사명</span>
                      <input
                        className="companyName"
                        type="text"
                        placeholder="회사명을 입력해 주세요."
                        name="cor_name"
                        value={cor_name}
                        onChange={handleOnChange}
                        ref={(el) => (useRefs.current[1] = el)}
                        title="회사명을 입력해주세요."
                      />
                    </label>
                    <label className="companyAddress wp100">
                      <span>회사 주소</span>
                      <div className="flex_column wp100">
                        <div className="wp100">
                          <input
                            type="text"
                            name="zipcode"
                            value={zipcode}
                            onClick={() => {
                              open({ onComplete: handleComplete });
                            }}
                            onChange={handleOnChange}
                            ref={(el) => (useRefs.current[2] = el)}
                            title="우편번호를 입력해주세요."
                          />
                          <button
                            type="button"
                            onClick={() => {
                              open({ onComplete: handleComplete });
                            }}
                          >
                            우편번호 검색
                          </button>
                        </div>
                        <input
                          type="text"
                          className="centerInput"
                          name="addr"
                          value={addr}
                          onChange={handleOnChange}
                          onClick={() => {
                            open({ onComplete: handleComplete });
                          }}
                          ref={(el) => (useRefs.current[3] = el)}
                          title="도로명주소를 입력해주세요."
                        />
                        <input
                          type="text"
                          placeholder="회사주소를 입력해 주세요."
                          name="addr_detail"
                          value={addr_detail}
                          onChange={handleOnChange}
                          ref={(el) => (useRefs.current[4] = el)}
                          title="상세주소를 입력해주세요."
                        />
                      </div>
                    </label>
                    <label>
                      <span>담당자명</span>
                      <input
                        type="text"
                        placeholder="담당자명을 입력해 주세요."
                        name="mng_name"
                        value={mng_name}
                        onChange={handleOnChange}
                        ref={(el) => (useRefs.current[5] = el)}
                        title="담당자명을 입력해주세요."
                      />
                    </label>
                    <label>
                      <span>연락처</span>
                      <div className="num">
                        <select
                          className="phone"
                          name="phone1"
                          value={phone1}
                          onChange={handleOnChange}
                        >
                          <option value="010">010</option>
                          <option value="011">011</option>
                          <option value="016">016</option>
                          <option value="017">017</option>
                          <option value="018">018</option>
                          <option value="019">019</option>
                        </select>
                        -
                        <input
                          type="text"
                          className="phone2"
                          maxLength="4"
                          name="phone2"
                          value={phone2?.replace(/[^0-9]/g, '') || ''}
                          onChange={handleOnChange}
                          ref={(el) => (useRefs.current[6] = el)}
                          title="연락처를 입력해주세요."
                        />
                        -
                        <input
                          type="text"
                          className="phone3"
                          maxLength="4"
                          name="phone3"
                          value={phone3?.replace(/[^0-9]/g, '') || ''}
                          onChange={handleOnChange}
                          ref={(el) => (useRefs.current[7] = el)}
                          title="연락처를 입력해주세요."
                        />
                      </div>
                    </label>
                  </div>
                  {isResponsive && (
                    <div className="right">
                      <div className="flex">
                        <span className="inputName">회사 주소</span>
                        <div className="flex_column">
                          <div>
                            <input
                              type="text"
                              value={zipcode}
                              name="zipcode"
                              onChange={handleOnChange}
                              onClick={() => {
                                open({ onComplete: handleComplete });
                              }}
                              ref={(el) => (useRefs.current[2] = el)}
                              title="우편번호를 입력해주세요."
                            />
                            <button
                              type="button"
                              onClick={() => {
                                open({ onComplete: handleComplete });
                              }}
                            >
                              우편번호 검색
                            </button>
                          </div>
                          <input
                            type="text"
                            className="centerInput"
                            value={addr}
                            name="addr"
                            onChange={handleOnChange}
                            onClick={() => {
                              open({ onComplete: handleComplete });
                            }}
                            ref={(el) => (useRefs.current[3] = el)}
                            title="도로명주소를 입력해주세요."
                          />
                          <input
                            type="text"
                            placeholder="회사주소를 입력해 주세요."
                            value={addr_detail}
                            name="addr_detail"
                            onChange={handleOnChange}
                            ref={(el) => (useRefs.current[4] = el)}
                            title="상세주소를 입력해주세요."
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <label className="wp100">
                  <span className="email">이메일</span>
                  <div className="mail">
                    <input
                      placeholder="이메일을 입력해 주세요."
                      value={emailAccount}
                      name="emailAccount"
                      onChange={handleOnChange}
                      ref={(el) => (useRefs.current[8] = el)}
                      title="이메일을 입력해주세요."
                    />
                    <span className="mailIcon">@</span>
                    <input
                      type="text"
                      value={emailDomain === '' ? emailDomain : emailDomain}
                      name="emailDomain"
                      onChange={handleOnChange}
                      ref={(el) => (useRefs.current[9] = el)}
                      title="이메일 도메인을 입력해주세요."
                    />
                    <select onChange={handleOnChange} value={emailDomain} name="emailDomain">
                      <option value="">직접입력</option>
                      <option value="gmail.com">gmail.com</option>
                      <option value="naver.com">naver.com</option>
                      <option value="hanmail.net">hanmail.net</option>
                    </select>
                  </div>
                </label>
                <label className="contentInquiry">
                  <span>문의 내용</span>
                  <textarea
                    name="contents"
                    placeholder="내용을 입력해 주세요."
                    value={contents}
                    onChange={handleOnChange}
                    ref={(el) => (useRefs.current[10] = el)}
                    title="문의 내용을 입력해주세요."
                  />
                </label>
                <div className="notice">
                  <span>
                    안내 사항<span className="blue">*</span>
                  </span>
                  <p>
                    (주)위더스 시큐리티 이하 “회사”는 개인정보보호법 및 정보통신망법에 의거 개인정보
                    수집 시 아래와 같은 사항을 알려드리며, <br />
                    본인의 동의를 받고 있으니 동의여부에 따른 서명을 해 주시기 바랍니다.
                  </p>
                </div>
              </div>
              <div className="ConsentUse">
                <ProductPersoanlInfo agree={agree} setAgree={setAgree} />
              </div>
              <div className="btn">
                <button className="apply">문의하기</button>
              </div>
            </div>
          </div>
        </form>
      </section>
      {closePopUp && <Confirmodal closePop={closePopup} />}
    </>
  );
};

export default ContactProduct;
